export default __webpack_public_path__ + "static/media/logo.13e19c5c.png";